module.exports = __webpack_public_path__ + "img/icon-speed-5.fe6fca13.svg";